import { Button } from "@/uiComponents/components/ui/button";
import { Loader2 } from "lucide-react";
import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  label: string;
  className?: string;
}

export const ReusableButton: React.FC<ButtonProps> = ({
  loading = false,
  label = "",
  className = "",
  disabled,
  ...rest
}) => {
  return (
    <Button
      className={` bg-[#191F29]  hover:bg-[#2A313D] active:bg-[#001533] text-white cursor-pointer ${className}`}
      type="submit"
      size={"lg"}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <Loader2 className="animate-spin" size={20} /> : label}
    </Button>
  );
};
